import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.8123 11.2511H13.2498V7.6886C13.2498 7.58547 13.1654 7.5011 13.0623 7.5011H11.9373C11.8342 7.5011 11.7498 7.58547 11.7498 7.6886V11.2511H8.18732C8.08419 11.2511 7.99982 11.3355 7.99982 11.4386V12.5636C7.99982 12.6667 8.08419 12.7511 8.18732 12.7511H11.7498V16.3136C11.7498 16.4167 11.8342 16.5011 11.9373 16.5011H13.0623C13.1654 16.5011 13.2498 16.4167 13.2498 16.3136V12.7511H16.8123C16.9154 12.7511 16.9998 12.6667 16.9998 12.5636V11.4386C16.9998 11.3355 16.9154 11.2511 16.8123 11.2511Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 1.5C6.70156 1.5 2 6.20156 2 12C2 17.7984 6.70156 22.5 12.5 22.5C18.2984 22.5 23 17.7984 23 12C23 6.20156 18.2984 1.5 12.5 1.5ZM12.5 20.7188C7.68594 20.7188 3.78125 16.8141 3.78125 12C3.78125 7.18594 7.68594 3.28125 12.5 3.28125C17.3141 3.28125 21.2188 7.18594 21.2188 12C21.2188 16.8141 17.3141 20.7188 12.5 20.7188Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AddCircleIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "add-circle",
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})